import { numify } from 'numify';
import { useTranslation } from 'react-i18next';
/////////////////////////////////////////////////////////////
import { secondsToHMS, formatHMS } from '@/app/shared/utils';

interface HardCardProps {
	name: string;
	id: number;
	image: string;
	gradient: string;
	value?: number;
	textValue?: string;
	type: 'daily' | 'permanent' | 'diamonds';
	cost?: number;
	level?: number;
	imageText?: string;
	isBlocked?: boolean;
	countdown?: number;
	hasCountdown?: boolean;
	onClick: (drawer: number) => void;
}

export const HackCard: React.FC<HardCardProps> = ({
	name,
	id,
	image,
	gradient,
	value,
	textValue,
	type,
	cost,
	level,
	imageText,
	isBlocked,
	countdown,
	onClick,
}: HardCardProps) => {
	/*********************
	// #region Hooks
	**********************/
	const { t } = useTranslation();

	/*********************
	// #region Template
	**********************/

	return (
		<div
			className={`${gradient} rounded-lg flex ${
				type !== 'daily' ? 'flex-1' : 'w-1/2'
			} flex-col justify-center cursor-pointer relative`}
			onClick={() => {
				if (!isBlocked) {
					onClick(id);
				}
			}}
		>
			{/* Header Card */}
			<div className="flex items-center justify-center mx-auto pt-6 px-6 min-h-[125px]">
				<img
					src={image}
					alt={name}
					className={`min-h-[80px] drop-shadow-xl`}
				/>
			</div>

			{/* Body Card */}
			<div className="flex flex-col gap-2 justify-center items-center w-full min-h-[100px] mx-auto">
				<p className="text-lg font-bold text-center">{name}</p>
				{type === 'daily' && textValue && value && (
					<p className="text-sm text-center">
						{textValue}
						{value}
					</p>
				)}

				{type === 'permanent' && cost && level && imageText && (
					<div className="flex justify-center items-center text-center">
						<img
							className="drop-shadow-lg"
							src={imageText}
							width={'15px'}
						/>

						<p className="text-sm">
							{numify(cost)} - Level: {level}
						</p>
					</div>
				)}

				{type === 'diamonds' && (
					<div className="flex justify-center items-center text-center gap-1">
						<img
							className="drop-shadow-lg"
							src={process.env.VITE_MINI_DIAMOND_IMAGE}
							width={'15px'}
						/>

						<p className="text-sm">Pay with gems</p>
					</div>
				)}
			</div>

			{isBlocked && countdown && (
				<div
					className={`rounded-lg p-6 flex flex-col  justify-center bg-customer-950/90 absolute top-0 left-0 w-full h-full items-center`}
				>
					<p className="text-xs text-center leading-tight mb-1 text-yellow-600">
						{t('general.timeLeft')}:{' '}
					</p>
					<p className="text-xs text-yellow-600 text-center">
						{formatHMS(secondsToHMS(countdown))}
					</p>
				</div>
			)}
		</div>
	);
};
